import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate',
    standalone: false
})
export class TruncatePipe implements PipeTransform {
  public transform(value: string | undefined, maxLength: number): string {
    if (!value) {
      return '';
    }

    const nullCheckedValue = value ?? '';
    const ellipsis = '...';

    return nullCheckedValue.length > maxLength ? `${nullCheckedValue.substring(0, maxLength + 1)}${ellipsis}` : nullCheckedValue;
  }
}
